/**
 * Utilities for building select options from translated entities.
 * Teachers don't have a direct `name` field —
 * their names come from `translations[].name`.
 */

export interface TeacherRecord {
  id: number | string;
  photoUrl?: string | null;
  translations?: { languageCode: string; name: string }[];
}

function getTranslatedName(
  translations: { languageCode: string; name: string }[] | undefined,
  fallback: string,
): string {
  if (!translations || translations.length === 0) {return fallback;}
  const ru = translations.find((t) => t.languageCode === 'ru');
  return ru?.name ?? translations[0].name ?? fallback;
}

export function buildTeacherOptions(
  items: TeacherRecord[],
): { label: string; value: string }[] {
  return items.map((t) => ({
    label: getTranslatedName(t.translations, `#${t.id}`),
    value: String(t.id),
  }));
}
